import api from "api";
import { useQuery } from "react-query";

export const useGetUsProviderGroupClinics = () => {
  return useQuery<{ items: { id: number; name: string }[] }>("getUsProviderGroupClinics", () =>
    // @ts-ignore
    api.parse("GET /v2/support/us_provider_group_clinics", { root: process.env.REACT_APP_API_URL_V2 })
  );
};
